module.exports = __webpack_public_path__ + "static/media/DSC_6305.5bfb89a4.jpg";